import { AppState, Action, InitialState, Types, AlertContent } from './app.model'

export function AppReducer(s: AppState = InitialState, a: Action): AppState {
  switch (a.type) {
    case Types.UpdateState: return { ...s, ...a.payload }
    case Types.LogOut:
      if (s.user) { s.user.removeToken() }
      s.user = null
      return s
    case Types.ImportedItem:
      if (a.payload.batch_number && s.user.batch_numbers.indexOf(a.payload.batch_number) < 0) {
        s.user.batch_numbers = [a.payload.batch_number].concat(s.user.batch_numbers)
      }
      if (a.payload.purchaser && s.user.purchasers.indexOf(a.payload.purchaser) < 0) {
        s.user.purchasers = [a.payload.purchaser].concat(s.user.purchasers)
      }
      s.alert = new AlertContent({ snackbar: true, msg: '成功入库，请勿重复入库', success: true })
      return s
    default: return s
  }
}



// WEBPACK FOOTER //
// ./src/app/store/app.reducer.ts